export default {
  header: {
    title: 'Recompensas',
  },
  content: {
    title: 'Tienes {{balance}} puntos',
    description: '¡Gasta {{amount}}, obtén {{rewards}} puntos! Añade artículos gratis a tu carrito con tus puntos.',
    articles: {
      title: 'Gana puntos con cada pedido',
      spend_description: 'Cada {{amount}} que gastas suma {{rewards}} puntos a tu cuenta.',
      redeem_title: 'Canjea tus puntos',
      redeem_description:
        '¡Canjea tus puntos por premios gratis! Empieza a ganar recompensas con {{minSpendingLimit}} puntos, equivalente a {{amount}} gastados',
      discounts_title: 'Descubre ventajas exclusivas',
      discounts_description: 'Desbloquea ofertas y descuentos exclusivos.',
    },
  },
};
